
import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { PollVotingStatusProps } from './types';

const PollVotingStatus: React.FC<PollVotingStatusProps> = ({ hasVoted, hasAnonymousVoted }) => {
  if (!hasVoted && !hasAnonymousVoted) return null;
  
  return (
    <div className="flex items-center gap-2 text-green-600 mb-3">
      <CheckCircle2 size={16} />
      <span>You've voted on this poll</span>
    </div>
  );
};

export default PollVotingStatus;
